import service from '../api/society.service';
//constants
const dataSociety = {
    societies: [],
    countries: [],
    responseSociety: null,
    errorSociety: ''
}
//types
const LIST_SOCIETY = 'LIST_SOCIETY';
const LIST_COUNTRIES_SOCIETY = 'LIST_COUNTRIES_SOCIETY';
const ERROR_SOCIETY = 'ERROR_SOCIETY';


//reducer
export default function societyReducer(state = dataSociety, action) {
    switch (action.type) {
        case LIST_SOCIETY:
            return { ...state, societies: action.payload };
        case ERROR_SOCIETY:
            return { ...state, errorSociety: action.payload };
        case LIST_COUNTRIES_SOCIETY:
            return { ...state, countries: action.payload };
        default:
            return { ...state };
    }
}
export const findCountries = (user) => async (dispatch) => {
    const response = await service.getSocieties(user).then((r) => {
        return r.data !== undefined ? r.data : r.response.data;
    });

    if (response.error !== undefined) {
        dispatch({
            type: ERROR_SOCIETY,
            payload: response
        });
        dispatch({
            type: LIST_COUNTRIES_SOCIETY,
            payload: ''
        });
    } else {
        let data = [];
        response.forEach(element => {
            
            const repetido = data.some(e => e.value === element.country.code);

            if (!repetido) {
                data.push({
                    value: element.country.code,
                    label: element.country.name + ' | ' + element.country.code,
                });
            }

        });
        dispatch({
            type: ERROR_SOCIETY,
            payload: ''
        });
        dispatch({
            type: LIST_COUNTRIES_SOCIETY,
            payload: data
        });
    }

}
export const findSocieties = (user) => async (dispatch) => {
    const response = await service.getSocieties(user).then((r) => {
        return r.data !== undefined ? r.data : r.response.data;
    });

    if (response.error !== undefined) {
        dispatch({
            type: ERROR_SOCIETY,
            payload: response
        });
        dispatch({
            type: LIST_SOCIETY,
            payload: ''
        });
    } else {
        let data = [];
        response.forEach(element => {
            data.push({
                value: element.code,
                label: element.name + ' | ' + element.code,
                country: element.country.code
            });
        });
        dispatch({
            type: ERROR_SOCIETY,
            payload: ''
        });
        dispatch({
            type: LIST_SOCIETY,
            payload: data
        });
    }

}
